import { ComponentData } from './types'

export type QuantityInputProps = {
  id: number
  quantity?: number
}

export default class QuantityInputData extends ComponentData {
  public id: number
  private initialQuantity: number

  constructor({ id, quantity = 0 }: QuantityInputProps) {
    super()
    this.id = id
    this.initialQuantity = quantity
  }

  public get quantity() {
    const cart = this.$store.cartStore.cart

    if (!cart) return this.initialQuantity

    return cart.items
      .filter(item => item.id === this.id)
      .reduce((sum, { quantity }) => sum + quantity, 0)
  }
}
